module.exports = __webpack_public_path__ + "static/img/point_icon_02.e898e25f.svg";